import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SEBType } from './model/SEBType';

interface TrainingSiteDetails {
    premise: { name: string };
    isOwner: boolean;
    isRelated: boolean;
}

interface ApplicationPlacement {
    endDate: string;
    trainingSite: TrainingSiteDetails;
}

interface ApplicationDetails {
    preregNumber: string;
    name: string;
    submittedDate: string;
    clinicalSpecialities?: string;
    placements?: ApplicationPlacement[];
    preRegVersion?: string;
    orielSchemeNumber?: string;
    seb?: SEBType;
}

@Component({
    selector: 'app-application-details',
    templateUrl: './applicationDetails.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ApplicationDetailsComponent implements OnInit {
    @Input() application!: ApplicationDetails;
    trainingSites: TrainingSiteDetails[] = [];
    hasPlacements = false;
    userSEBType: string = '-';

    constructor() { }

    ngOnInit() {
        const placements = this.application.placements ?? [];
        this.hasPlacements = placements.length > 0;
        if (this.hasPlacements) {
            const hasMoreThanOnePlacement = placements.length > 1;
            (hasMoreThanOnePlacement) ? this.sortPlacements(placements) : this.trainingSites.push(placements[0].trainingSite);
        }
        if (this.application?.seb) this.userSEBType = SEBType[this.application.seb] ?? '-';
    }

    get isPreRegVersionNew() {
        return this.application?.preRegVersion === 'new';
    }

    sortPlacements(placements: ApplicationPlacement[]): void {
        [...placements].sort((placement1, placement2) => {
            return new Date(placement1.endDate).getTime() - new Date(placement2.endDate).getTime();
        }).forEach(placement => {
            this.trainingSites.push(placement.trainingSite);
        });
    }


}
